// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Filtro_AplicaFiltrosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for /filtro/aplicaFiltros
 *
 * Applies franchise/date filter scoping.
 */
import { registerContract } from './validate'

export interface Filtro_AplicaFiltrosInput {
Franquias: Record<number | string, {
FranquiaID?: number,
}>
DataInicio: string
DataFim: string
}

registerContract('Filtro_AplicaFiltrosInput', {
  Franquias:  { type: 'object',  required: true },
  DataInicio: { type: 'string',  required: true },
  DataFim:    { type: 'string',  required: true },
})
